/**
 * https://www.owasp.org/index.php/Cross-Site_Request_Forgery_%28CSRF%29_Prevention_Cheat_Sheet
 * @param prefix
 * @returns {string}
 */
export const generateCsrf = (prefix = null) => {
  const token = prefix + Math.random().toString();
  window.sessionStorage.setItem("csrf_token", token);
  return token;
};

export const getCsrf = () => window.sessionStorage.getItem("csrf_token");



// WEBPACK FOOTER //
// ./src/helpers/Csrf.js